import C from 'classnames';

import s from './styles.module.scss';

import type { FC, ReactNode } from 'react';
import type { TTileTone } from './types';

interface IProps {
  icon: ReactNode;
  label: string;
  tone?: TTileTone;
  title?: string;
  onClick?: () => void;
  dataCy?: string;
}

/**
 * One of the four control tiles. An engaged tile REPORTS rather than instructs —
 * the caller passes "On hold" / "Muted" as the label, not "Hold" / "Mute" —
 * which is what makes the row readable in a glance mid-conversation.
 *
 * `unavailable` renders a real disabled button, not a hidden one: the slot and
 * the size are kept so nothing shifts when the patient answers.
 */
const ControlTile: FC<IProps> = ({
  icon,
  label,
  tone = 'default',
  title,
  onClick,
  dataCy,
}) => (
  <button
    type="button"
    className={C(s.tile, s[`tile-${tone}`])}
    onClick={onClick}
    disabled={tone === 'unavailable'}
    aria-pressed={tone === 'engaged'}
    title={title}
    data-cy={dataCy}
  >
    <span className={s['tile-icon']}>{icon}</span>
    <span className={s['tile-label']}>{label}</span>
  </button>
);

export default ControlTile;
